module.exports = __webpack_public_path__ + "img/home_icon_selected.bec0d42d.svg";